import { ShieldCheck } from "lucide-react";
import { TRUST_ITEMS } from "../data/site";
import { useReveal } from "../hooks/useReveal";

export default function TrustCompliance() {
    const ref = useReveal();
    return (
        <section
            id="trust"
            data-testid="trust-section"
            className="bg-neutral-bg py-20 sm:py-24"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <div ref={ref} className="reveal mb-12 max-w-3xl">
                    <span className="text-xs uppercase tracking-[0.22em] text-brand-red">
                        Trust &amp; Compliance
                    </span>
                    <h2 className="mt-3 font-display text-3xl font-bold tracking-[-0.025em] sm:text-5xl">
                        Registered, audited, export-ready.
                    </h2>
                </div>
                <div className="grid gap-px overflow-hidden rounded-3xl border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-4">
                    {TRUST_ITEMS.map((it) => (
                        <div
                            key={it.title}
                            data-testid={`trust-${it.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="bg-white p-6 transition-colors hover:bg-brand-turmeric/10"
                        >
                            <span className="grid h-10 w-10 place-items-center rounded-xl bg-brand-red/10 text-brand-red">
                                <ShieldCheck className="h-5 w-5" />
                            </span>
                            <h3 className="mt-4 font-display text-base font-bold tracking-tight">
                                {it.title}
                            </h3>
                            <p className="mt-1.5 text-sm leading-relaxed text-ink-muted">
                                {it.body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
